
(async () => {
    const { Core } = await importModule('Core');

    const clampQuantity = (input, wrapper) => {
        const limit = parseInt(wrapper?.dataset.limit, 10) || Infinity;
        let value = parseInt(input.value, 10) || 1;
        value = Math.max(1, value);
        if (value > limit) {
            value = limit;
            wrapper?.classList.add('@max-reached');
        } else {
            wrapper?.classList.remove('@max-reached');
        }
        input.value = value;
        return value;
    };

    if (!window.__productCardPurchaseControlsBound) {
        window.__productCardPurchaseControlsBound = true;

        document.addEventListener('click', (event) => {
            const optionsTrigger = event.target.closest('[data-product-card-options]');
            if (!optionsTrigger) return;

            const scope = optionsTrigger.closest('[data-quantity-scope]');
            const input = scope?.querySelector('input[name="quantity"]');
            window.__productCardPendingQuantity = input ? clampQuantity(input, input.closest('[data-product-card-quantity]')) : 1;
        }, true);

        document.addEventListener('click', (event) => {
            const button = event.target.closest('[data-qty-minus], [data-qty-plus]');
            if (!button) return;

            const wrapper = button.closest('[data-product-card-quantity], [data-express-option-quantity]');
            if (!wrapper) return;

            const input = wrapper.querySelector('input[name="quantity"]');
            if (!input) return;

            event.preventDefault();
            let value = clampQuantity(input, wrapper);
            const limit = parseInt(wrapper.dataset.limit, 10) || Infinity;

            if (button.hasAttribute('data-qty-minus')) {
                value = Math.max(1, value - 1);
            } else if (value < limit) {
                value += 1;
            } else {
                wrapper.classList.add('@max-reached');
            }

            input.value = value;
            input.dispatchEvent(new Event('input', { bubbles: true }));
        });

        document.addEventListener('input', (event) => {
            const input = event.target;
            const wrapper = input.closest?.('[data-product-card-quantity], [data-express-option-quantity]');
            if (!wrapper || input.name !== 'quantity') return;
            clampQuantity(input, wrapper);
        });
    }

    if (customElements.get('product-card')) return;

    customElements.define('product-card', class extends Core {
        elements = {
            swatches: '[data-element="swatches"]'
        }

        render() {
            this.$swatches?.addEventListener('mouseover', this._onMouseOver.bind(this))
            this.$swatches?.addEventListener('mouseout', this._onMouseOut.bind(this))

        }
        _onMouseOver({ srcElement }) {
            const swatchNumber = srcElement.dataset.swatchNumber;
            if (swatchNumber) {
                this.selectedSwatch = swatchNumber;
            }
        }
        _onMouseOut({toElement}) {
            if (toElement.dataset.element !== 'swatches') {
                this.selectedSwatch = null;
            }
        }

        set selectedSwatch(number) {
            this.dataset.selectedSwatch = number;
        }
    })
})();
